<template lang="html">
  <v-snackbar
    v-if="popUp && (alerts && alerts.length > 0)"
    v-model="snackbar"
    :color="alertType"
    app
    :timeout="timeout"
  >
    <div class="d-flex align-center">
      <v-icon>mdi-alert-circle-outline</v-icon>
      <AlertListItems :alerts="alerts" :verbose="verbose" pop-up />
    </div>
    
  </v-snackbar>
  <v-alert
    dense
    text
    :type="alertType"
    v-else-if="!popUp && (permanent || (alerts && alerts.length > 0))"
  >
    <AlertListItems :alerts="alerts" :verbose="verbose" />
  </v-alert>
</template>

<script>
import AlertListItems from './AlertListItems.vue';

export default {
  name: 'AlertList',
  components: { AlertListItems, },
  props: {
    alerts: {
      // REFACTOR: provide array of specific alert objects with icon?, text, type, link?, actions?
      type: Array,
      default: () => [],
    },
    alertType: {
      // REFACTOR: allow each alert to specify its own type instead of setting for the entire bunch
      type: String,
      default: 'error',
    },
    permanent: {
      // Force always visible, even if no errors.
      type: Boolean,
      default: false,
    },
    verbose: {
      type: Boolean,
      default: false,
    },
    popUp: {
      type: Boolean,
      default: false,
    },
    timeout: {
      type: String,
      default: '-1', //permanent
    }
  },
  data() {
    return {
      snackbar: true,
    };
  },
  watch: {
    alerts: {
      /*show snackbar when new alerts are added (after timeout is finished, scnackbar is auto-set to false)
      this solves the problem  when we throw an error, wait for timeout, and throw another error, snackbar wouldnt show */
      handler(newVal) {
        this.snackbar = true;
      }
    },
  },
};
</script>

<style lang="css" scoped>
/deep/.v-snack__content {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
